import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class GoodsRecordLotteryApp extends React.Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            gi: this.props.match.params["id"] || "",
            list: [],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "編號",
                "抽獎序號",
                "抽獎者",
                "兌換時間"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData() {
        var tmpData = {
            gi: this.state.gi
        };
        API.GetGoodRecord(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index) {
        console.log(index);
        const tmp = index.split("_")[1];
        window.open("/#/member/detail/" + tmp);
    }

    onDataUpdated(data) {
        console.log(this);
        if (data && data.data) {
            console.log(data);
            const tmp = [];
            /* {
                "ct": 1552027146872,
                "ac": "MAbSf6JxO",
                "data": [
                    {
                        "ct": 1551056198872,
                        "ex_time": 0,
                        "code": "36d08e53f6",
                        "serial": {
                            "recv_type": "0",
                            "key": "SETQ6QU9H6WK"
                        },
                        "accID": "AbKjYzLL"
                    },
                    {
                        "ct": 1551248489479,
                        "ex_time": 0,
                        "code": "91b34c14a0",
                        "serial": {
                            "recv_type": "0",
                            "key": "SETDS3XY59H7"
                        },
                        "accID": "AbKjYzLL"
                    }
                ]
            } */
            for (let index in data.data) {
                const tmpObj = data.data[index];
                // "編號",
                // "序號",
                // "兌換狀態",
                // "兌換者",
                // "兌換時間"
                tmp.push({
                    key: tmpObj.serial.key + "_" + tmpObj.accID,
                    data: [
                        (parseInt(index) + 1),
                        tmpObj.serial.key,
                        tmpObj.accID,
                        Tools.getFormatDate(tmpObj.ct),
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list}
                    fields={fields}
                    title={"所有抽獎名單"}
                    onRowClicked={onListViewClicked} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(GoodsRecordLotteryApp),
//     document.getElementById('root')
// );
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GoodsRecordLotteryApp))